import { authenticationService } from '../services'
import router from '../router'

const state = {
  status: 'anonymous',
  user: {},
  oAuthCredentials: {},
  roles: [
    { id: 'ROLE_ADMIN', label: 'Administrateur' },
    { id: 'ROLE_CONTRIBUTOR', label: 'Contributeur' },
    { id: 'ROLE_READER', label: 'Lecteur' }
  ]
}

const getters = {
  getUser (state) {
    return state.user
  },
  getOAuthCredentials (state) {
    return state.oAuthCredentials
  },
  getRoles (state) {
    return state.roles
  },
  isAuthenticated (state) {
    return state.status === 'authenticated' && state.user.value
  },
  isAdmin (state) {
    if (state.status !== 'authenticated' || !state.user.value) return false
    return state.user.user.roles && state.user.user.roles.indexOf('ROLE_ADMIN') > -1
  },
  isContributor (state) {
    if (state.status !== 'authenticated' || !state.user.value) return false
    return state.user.user.roles && state.user.user.roles.indexOf('ROLE_CONTRIBUTOR') > -1
  },
  isReader (state) {
    if (state.status !== 'authenticated' || !state.user.value) return false
    return state.user.user.roles && state.user.user.roles.indexOf('ROLE_READER') > -1
  }
}
const mutations = {
  loginRequest (state, user) {
    state.user = user
  },
  loginSuccess (state, user) {
    state.status = 'authenticated'
    state.user = user
    router.push('/')
  },
  logout (state) {
    state.status = 'anonymous'
    state.user = null
    state.oAuthCredentials = null
  },
  setUserFromLocalstorage (state) {
    state.oAuthCredentials = JSON.parse(window.localStorage.getItem('oauth-credentials'))
    state.user = JSON.parse(window.localStorage.getItem('auth'))
    state.status = 'authenticated'
  }
}

const actions = {
  /**
   * Query API to unvalidate auth token, then destroy it from localStorage and redirect user
   * @param {Object} context
   * @returns {Promise} Pipe back axios Promise from the service to the component
   */
  logout (context) {
    context.dispatch('loader/startLoading', 'authentication/logout', { root: true })
    return authenticationService.logout()
      .then(() => {
        context.commit('logout')
      })
      .finally(() => {
        router.push('/login')
        context.dispatch('loader/stopLoading', 'authentication/logout', { root: true })
      })
  },
  /**
   * Attempt to load user's credentials from localStorage into vuex
   * @param {Object} context
   */
  setUserFromLocalstorage (context) {
    const appCredentials = JSON.parse(window.localStorage.getItem('auth'))
    const oauthCredentials = JSON.parse(window.localStorage.getItem('oauth-credentials'))

    /**
     * We pull credentials from localStorage in the eventuality of a vuex state loss
     * if said credentials aren't found on the vuex state, then try and fetch them from the local Storage
     */
    if (
      (state.status === 'anonymous' || state.user.value === 'undefined') &&
      appCredentials &&
      appCredentials.value &&
      oauthCredentials &&
      oauthCredentials.access_token
    ) {
      context.commit('setUserFromLocalstorage')
    }
  },
  setOAuthCredentials (context, credentials) {
    window.localStorage.setItem('oauth-credentials', JSON.stringify(credentials))
    return authenticationService.setOAuthCredentials(credentials)
      .then(response => {
        context.commit('setUserFromLocalstorage')
        return response
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
